<div mat-dialog-content>
  <div [ngClass]="{'panel-step':true,'active':listPanels.merchLoop}">
    <div class="row">
      <div class="col-md-6 border-right">
        <div class="titleWindow">Welcome to Merchloop</div>
        <p class="desc">Create a Store and Start Selling with our Platform in Minutes</p>
        <br />
        <br />
        <img src="assets/img/MerchLoop-Iconwithtext-p-500.png" alt="" class="rounded  img-fluid" style="max-width:200px;">
      </div>
      <div class="col-md-6">
        <img src="assets/img/PayPal-Logo.png" alt="" class="rounded text-center img-fluid" style="max-width:100px;">
        <br />
        <small>
          Please enter the paypal account you would like to link which will allow MerchLoop to make commission payments.
        </small>
        <br />
        <br />
        <mat-form-field>
          <input matInput placeholder="Paypal Account Holder Name" required type="text" [(ngModel)]="namePaypal">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Paypal email" #emailInput required (change)="ValidInput()" type="email" [(ngModel)]="emailPaypal">
        </mat-form-field>
        <br />
        <button class="mat-btn pull-right" mat-raised-button style="background: #ec4745!important;" [disabled]="disabledForm"
                (click)="submitFormMerchLoop()">
          Save <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>

  </div>
  <div [ngClass]="{'panel-step':true,'active':listPanels.final}">
    <div class="content-final text-center">
      <i class="fa fa-check-circle" aria-hidden="true" style="font-size: 70px; color: #8BC34A;"></i>
      <br/>
      <div class="titleFinal">That's it!!!</div>
      <p>
        Please fill W9 form details to receive commission and make store online.
        <br />
        <a (click)="dialogRef.close();" [routerLink]="[ '/store/W9Form']" style="font-size: 14px;line-height: 39px;" class="text-danger pulsate">&nbsp;Click to Submit W9 Details</a>.
      </p>
    </div>
  </div>
</div>
<div mat-dialog-actions>
</div>
